export const projects = [
					{
						name: "Progress Blog",
						color: "blue",
						description: `This a blog that I post an update everyday about what and how I'm learning. I created this blog using Gatsby and Contentful`,
						githubURL:
							"https://github.com/thorski1/New-Gatsby-Progress-Blog",
						siteURL:
							"https://sam-thoyre-progress-blog.netlify.com/",
						image: "/assets/ProgressBlog2.png",
					},
					{
						name: "Find Your Superhero",
						color: "blue",
						description:
							"This app was built using React with TypeScript. State is primarily managed with the Context/Reducer pattern.",
						githubURL:
							"https://github.com/thorski1/Superheroes",
						siteURL:
							"https://find-your-superhero.netlify.app",
						image: "/assets/superhero-project.png",
					},
					{
						name: "Code Party",
						color: "blue",
						description: `This is an app similar to Meetups, but specifically for people looking to create projects together in a home environment.  Users can host a "Code Party" where users will get together and create projects using a specific technology, such as React or Vue.`,
						githubURL:
							"https://github.com/thorski1/CodePartyReact",
						siteURL:
							"https://codeparty-c6656.firebaseapp.com",
						image: "/assets/CodeParty.png",
					},
					{
						name: "E-Commerce Clothing Store",
						color: "grey",
						description:
							"This is an incredibly comprehensive E-Commerce demo app that uses React, Redux, Firebase, and Stripe.",
						githubURL:
							"https://github.com/thorski1/ECommerceClothingReact",
						siteURL:
							"https://sams-crwn-clothing.herokuapp.com/",
						image: "/assets/CRWN.png",
					},
				];
